import { add, isSameDay, format, isValid, isBefore, isAfter } from 'date-fns';

export const useAvailabilityDates = () => {
  const { booking } = useBooking();

  function getAvailabilityDates(accommodationCalendar) {
    const ranges = accommodationCalendar;
    if (!ranges?.length) return;

    try {
      let datesAreInRange = false;
      const startDate = new Date(booking.value.date_from);
      const endDate = new Date(booking.value.date_to);

      if (!isValid(startDate) || !isValid(endDate)) return;

      for (const interval of ranges) {
        const intervalStartDate = new Date(interval.date_from);
        const intervalEndDate = new Date(interval.date_to);

        if ((isAfter(startDate, intervalStartDate) || isSameDay(startDate, intervalStartDate)) && (isBefore(endDate, intervalEndDate) || isSameDay(endDate, intervalEndDate))) {
          datesAreInRange = true;
          return { from: format(startDate, 'yyyy-MM-dd'), to: format(endDate, 'yyyy-MM-dd') };
        }
      }

      if (!datesAreInRange) {
        let newStartDate = null;
        let newEndDate = null;
        let validRangeFound = false;

        for (const interval of ranges) {
          const intervalEnd = new Date(interval.date_to);
          
          // Check if we can fit both the start date and next day in this interval
          const potentialStartDate = new Date(interval.date_from);
          const potentialEndDate = add(potentialStartDate, { days: 1 });
          
          if ((isBefore(potentialEndDate, intervalEnd) || isSameDay(potentialEndDate, intervalEnd))) {
            newStartDate = format(potentialStartDate, 'yyyy-MM-dd');
            newEndDate = format(potentialEndDate, 'yyyy-MM-dd');
            validRangeFound = true;
            return { from: format(newStartDate, 'yyyy-MM-dd'), to: format(newEndDate, 'yyyy-MM-dd') };
          }
        }

        if (!validRangeFound) return false;
      }
    } catch(error) {
      console.log('Error in getting availability dates', error);
    }
  }

  async function updateSearchDates(accommodationAvailabilityCalendar, datesCalculated = false) {
    // every unit inside accommodationsData has the availability calendar
    const availabilityDates = !datesCalculated ? getAvailabilityDates(accommodationAvailabilityCalendar) : accommodationAvailabilityCalendar;
    if (availabilityDates) {
      if (!(isSameDay(availabilityDates.from, booking.value.date_from && isSameDay(availabilityDates.to, booking.value.date_to)))) {
        booking.value.date_from = availabilityDates.from;
        booking.value.date_to = availabilityDates.to;
        booking.value.dates = [availabilityDates.from, availabilityDates.to];
        if (import.meta.client) sessionStorage.setItem('booking', JSON.stringify(booking.value))
      }
    }
  }

  return {
    getAvailabilityDates,
    updateSearchDates,
  }
}
